import { useMemo } from 'react';
import { useDashboard } from '../Contexts/DashboardContext';
import * as courseTime from '../utils/courseTime';

// Binds the course zone from DashboardContext into the pure courseTime
// helpers, so components call them without threading a zone argument.
//
// The subscription is the point: the returned object changes identity whenever
// the zone changes, which re-renders every consumer once dashboard_status
// delivers the course zone. Reading a module-level variable instead left any
// component that mounted before the first poll formatting in the fallback zone
// for the rest of its life.
export default function useCourseTime() {
  const { timezone } = useDashboard();

  return useMemo(() => courseTime.bind(timezone), [timezone]);
}
